import { Map } from 'immutable';

import * as types from './types';

const initialState = Map({});

const selectedUsersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.TOGGLE_USER_SELECTION: {
      return state.has(`${payload.id}`) ?
        state.delete(`${payload.id}`) :
        state.set(`${payload.id}`, payload);
    }
    case types.SET_USERS_SELECTION: {
      if (payload.checked) {
        return state.merge(payload.users);
      }
      return state.withMutations((newState) => (
        payload.users.forEach((user) => newState.delete(user.id))
      ));
    }
    case types.CLEAR_USERS_SELECTION:
      return Map();
    default:
      return state;
  }
};

export default selectedUsersReducer;
